import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaBell,
  FaSearch,
  FaCaretDown,
  FaCog,
  FaTimes,
  FaCheck,
  FaSave,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { v4 as uuidv4 } from "uuid";
import Sidebar from "./Sidemenu";

const Content = () => {
  const [category, setCategory] = useState("");
  const [showCategoryOptions, setShowCategoryOptions] = useState(false);
  const [language, setLanguage] = useState("");
  const [published, setPublished] = useState(false);
  const [publishAt, setPublishAt] = useState("");
  const [unpublishAt, setUnpublishAt] = useState("");
  const [internalNames, setInternalName] = useState("");
  const [contentDetails, setContentDetails] = useState("");
  const [storageLocation, setStorageLocation] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [description, setDescription] = useState("");
  const [imageMapping, setImageMapping] = useState({});
  const [title, setTitle] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [blockSearchEngines, setBlockSearchEngines] = useState(false);
  const [previewURL, setPreviewURL] = useState(null);
  const [showAccountOptions, setShowAccountOptions] = useState(false);
  const [storageType, setStorageType] = useState("Local"); // New state for storage type
  const navigate = useNavigate();

  const toggleAccountOptions = () => {
    setShowAccountOptions(!showAccountOptions);
  };

  const handleStorageTypeChange = (selectedStorageType) => {
    setStorageType(selectedStorageType);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];

    const reader = new FileReader();
    reader.onloadend = () => {
      if (file) {
        setImagePreview(reader.result);
        setUploadedImage(URL.createObjectURL(file));
      }
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["undo", "redo"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "undo",
    "redo",
  ];

  const handleDescriptionChange = (value) => {
    setDescription(value);
  };

  const handlePublishedSelect = (value) => {
    setPublished(value === "Yes");
  };

  const handleSaveAndClose = async () => {
    try {
      const assetId = uuidv4();
      const data = {
        category,
        language,

        publishAt,
        unpublishAt,
        blockSearchEngines,

        internalNames,
        contentDetails,
      };
      console.log(data);

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dynamiccontent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        console.log("Asset details saved successfully");

        // Map the title to the image file
        setImageMapping((prevMapping) => {
          const mappedImage = selectedFile ? selectedFile.name : "";
          console.log(`Mapped Title: ${title}, Mapped Image: ${mappedImage}`);

          return {
            ...prevMapping,
            [title]: mappedImage,
          };
        });

        const asset = { id: assetId, title, imagePreview };

        // Save the mapped file in the imageMapping state
        setImageMapping((prevMapping) => {
          console.log(
            `Saved Title: ${title}, Saved Image: ${asset.imagePreview}`
          );

          return {
            ...prevMapping,
            [title]: asset.imagePreview,
          };
        });
      } else {
        console.error("Failed to save asset details");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleApply = () => {
    const assetId = uuidv4();
    // Add code for handling Apply button click
  };

  const handleCancel = () => {
    navigate("/ContentGrid");
    setCategory("");
    setLanguage("");
    setPublished(false);
    setPublishAt("");
    setUnpublishAt("");
    setBlockSearchEngines(false);
    setStorageLocation("");
    setSelectedFile(null);
    setUploadedImage(null);
    setDescription("");
    setPreviewURL(null);
    setImagePreview("");
  };

  const handleCategorySelect = (selectedCategory) => {
    setCategory(selectedCategory);
    setShowCategoryOptions(false);
  };

  const handleLanguageSelect = (selectedLanguage) => {
    setLanguage(selectedLanguage);
  };

  const handlePublishAtSelect = (value) => {
    setPublishAt(value);
  };

  const handleUnpublishAtSelect = (value) => {
    setUnpublishAt(value);
  };

  return (
    <div className="container-fluid" style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ width: "100%", height: "100vh", overflowY: "auto" }}>
        <div style={{marginTop:'50px'}}>        {/* Second rectangle */}
        <div
          className="content-container"
          style={{
            border: "1px solid #ccc",
            height: "60px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: "1000",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "30px",
              marginLeft: "30px",
            }}
          >
            <span>New Dynamic Content</span>
          </div>
          <div className="d-flex">
            <button
              className="btn btn-white"
              style={{ border: "1px solid #ccc" }}
              onClick={handleSaveAndClose}
            >
              <FaSave className="mr-0" style={{ color: "#007bff" }} /> Save &
              Close
            </button>
            <button
              className="btn btn-white mx-2"
              style={{ border: "1px solid #ccc" }}
              onClick={handleApply}
            >
              <FaCheck className="" style={{ color: "#007bff" }} /> Save
            </button>
            <button
              className="btn btn-white"
              style={{ border: "1px solid #ccc" }}
              onClick={handleCancel}
            >
              <FaTimes className="" style={{ color: "red" }} /> Cancel
            </button>
          </div>
        </div>

        <div className="d-flex" style={{justifyContent:'space-between'}}>
        <div className="content-container m-5">
          <h2>Details</h2>
          <div className="form-group">
            <label htmlFor="internalName" style={{ marginTop: "10px" }}>
              Internal Name
            </label>
            <input
              type="text"
              className="form-control"
              id="internalName"
              placeholder="Enter internal name"
              style={{ marginTop: "10px" }}
              value={internalNames}
              onChange={(e) => setInternalName(e.target.value)}
            />
          </div>

          <h2>Content</h2>
          <input
            type="text"
            className="form-control"
            id="contentDetails"
            placeholder="Enter Content Details"
            style={{ marginTop: "10px" }}
            value={contentDetails}
            onChange={(e) => setContentDetails(e.target.value)}
          />
        </div>
        {/* Form Controls */}
        <div
          className="content-container"
          style={{
            border: "1px solid #ccc",
          }}
        >
          <div
            className="form-group"
            style={{  width: "100%" }}
          >
            <label
              htmlFor="category"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "100px",
                fontWeight: "bold",
              }}
            >
              Category
            </label>
            <select
              className="form-control mb-2"
              id="category"
              value={category}
              onChange={(e) => handleCategorySelect(e.target.value)}
              style={{ width: "100%" }}
            >
              <option value=""></option>
              <option value="Category 1">Uncategorized</option>
              <option value="Category 2">Create New Category..</option>
            </select>
          </div>

          <div
            className="form-group"
            style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}
          >
            <label
              htmlFor="language"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "100px",
                fontWeight: "bold",
              }}
            >
              Language
            </label>
            <select
              className="form-control mb-2"
              id="language"
              value={language}
              onChange={(e) => handleLanguageSelect(e.target.value)}
              style={{ width: "100%" }}
            >
              <option value=""></option>
              <option value="English">English</option>
              <option value="Spanish">Spanish</option>
            </select>
          </div>

          <div
            className="form-group"
            style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}
          >
            <label
              htmlFor="blockSearchEngines"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "200px",
                fontWeight: "bold",
              }}
            >
              Published{" "}
            </label>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "60%",
              }}
            >
              <label style={{ width: "35%" }}>
                <input
                  type="radio"
                  value="Yes"
                  checked={published}
                  onChange={() => handlePublishedSelect("Yes")}
                />{" "}
                Yes
              </label>
              <label style={{ width: "45%" }}>
                <input
                  type="radio"
                  value="No"
                  checked={!published}
                  onChange={() => handlePublishedSelect("No")}
                />{" "}
                No
              </label>
            </div>
          </div>

          <div
            className="form-group"
            style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}
          >
            <label
              htmlFor="publishAt"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "250px",
                fontWeight: "bold",
              }}
            >
              Publish at (Date and Time)
            </label>
            <input
              type="datetime-local"
              className="form-control mb-2"
              id="publishAt"
              value={publishAt}
              onChange={(e) => handlePublishAtSelect(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>

          <div
            className="form-group"
            style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}
          >
            <label
              htmlFor="unpublishAt"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "250px",
                fontWeight: "bold",
              }}
            >
              Unpublish at (Date and Time)
            </label>
            <input
              type="datetime-local"
              className="form-control mb-2"
              id="unpublishAt"
              value={unpublishAt}
              onChange={(e) => handleUnpublishAtSelect(e.target.value)}
              style={{ width: "100%" }}
            />
          </div>

          <div
            className="form-group"
            style={{ marginBottom: "20px", marginRight: "10px", width: "100%" }}
          >
            <label
              htmlFor="blockSearchEngines"
              style={{
                marginBottom: "5px",
                textAlign: "left",
                width: "200px",
                fontWeight: "bold",
              }}
            >
              Block search engines from indexing this file{" "}
            </label>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "60%",
              }}
            >
              <label style={{ width: "35%" }}>
                <input
                  type="radio"
                  value="Yes"
                  checked={published}
                  onChange={() => handlePublishedSelect("Yes")}
                />{" "}
                Yes
              </label>
              <label style={{ width: "45%" }}>
                <input
                  type="radio"
                  value="No"
                  checked={!published}
                  onChange={() => handlePublishedSelect("No")}
                />{" "}
                No
              </label>
            </div>
          </div>
        </div></div>
      </div>
    </div></div>

  );
};

export default Content;
